module.exports = __webpack_public_path__ + "img/main-03-10-AT.eda59ad1.png";